var n = function n(_n) {
  return "signIn" === _n || "signUp" === _n;
};

export { n as isSignInOrSignUpRoute };